import {HttpError} from './http-error';

export class BadDataError extends HttpError {
}
